import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import React, { createContext, useContext, useMemo } from "react";
//Limitless imports
import { ClientContext } from "../../../common/utils";
import { fetchGroupResponseTime } from "../../apis/group-response-time-api/GroupResponseTimeAPI";
var GroupResponseTimeContext = createContext({});
export var GroupResponseTimeContextProvider = function GroupResponseTimeContextProvider(_ref) {
  var children = _ref.children,
      delayNonEssentialCalls = _ref.delayNonEssentialCalls;
  var hook = useGroupResponseTime(delayNonEssentialCalls);
  var context = useMemo(function () {
    return _objectSpread({}, hook);
  }, [hook.timeSince]);
  return /*#__PURE__*/React.createElement(GroupResponseTimeContext.Provider, {
    value: context
  }, children);
};
export var useGroupResponseTimeContext = function useGroupResponseTimeContext() {
  return useContext(GroupResponseTimeContext);
};

var useGroupResponseTime = function useGroupResponseTime(delayNonEssentialCalls) {
  var _React$useState = React.useState({
    time: 0,
    loading: false
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      timeSince = _React$useState2[0],
      setTimeSince = _React$useState2[1];

  React.useEffect(function () {
    if (ClientContext._groupName && !delayNonEssentialCalls) {
      loadResponseTime();
    }
  }, []);

  var loadResponseTime = function loadResponseTime() {
    setTimeSince(_objectSpread({}, timeSince, {
      loading: true
    }));
    fetchGroupResponseTime(function (result) {
      setTimeSince(_objectSpread({}, timeSince, {
        loading: false,
        time: result.time
      }));
    });
  };

  return {
    loadResponseTime: loadResponseTime,
    timeSince: timeSince
  };
};